module.exports = __webpack_public_path__ + "assets/img/logo-ithrive.e644b1a0.png";